import React from "react";
import {
  Box,
  Container,
  Paper,
  Typography,
  Button,
  Alert,
} from "@mui/material";
import { styles } from "./AuthPage.styles";

export default function VerifyEmail({
  handleResendVerification,
  loading,
  error,
  verificationMessage,
  onBackToSignIn,
}) {
  const handleBackToSignIn = () => {
    localStorage.removeItem("needsVerification");
    localStorage.removeItem("pendingVerificationEmail");
    localStorage.removeItem("token");

    onBackToSignIn();
  };

  return (
    <Box>
      <Container
        maxWidth="sm"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Paper elevation={3} sx={styles.paper}>
          <Typography variant="h5" sx={{ mb: 2, textAlign: "center" }}>
            Email Verification Required
          </Typography>
          <Typography sx={{ mb: 3, textAlign: "center" }}>
            Please check your email for a verification link. Click the link to
            verify your account.
          </Typography>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleResendVerification}
            disabled={loading}
            sx={styles.submitButton}
          >
            {loading ? "Sending..." : "Resend Verification Email"}
          </Button>
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            onClick={handleBackToSignIn}
            sx={{ mt: 2 }}
          >
            Back to Sign In
          </Button>
        </Paper>
      </Container>
      {verificationMessage && (
        <Alert severity="success" sx={{ ...styles.errorAlert, marginTop: 5 }}>
          {verificationMessage}
        </Alert>
      )}

      {error && (
        <Alert severity="error" sx={styles.errorAlert}>
          {error}
        </Alert>
      )}
    </Box>
  );
}
